/**
 * Utility functions for dashboard components
 */

/**
 * Safely access nested properties in dashboard data
 * @param data Object containing dashboard data
 * @param path Dot-notation path to the property (e.g. 'formatted.payouts.netPaidTotal')
 * @param fallbackValue Value to return if property doesn't exist
 */
export function getDataOptional(
  data: any,
  path: string,
  fallbackValue: any = false
): any {
  if (!data) return fallbackValue;
  if (!path || typeof path !== 'string') return fallbackValue;

  const dangerousProps = Object.create(null);
  dangerousProps['__proto__'] = true;
  dangerousProps['constructor'] = true;
  dangerousProps['prototype'] = true;

  try {
    const pathParts = path.split('.');
    let current: any = data;

    for (const part of pathParts) {
      if (dangerousProps[part]) {
        return fallbackValue;
      }

      if (
        current === undefined ||
        current === null ||
        typeof current !== 'object' ||
        !Object.prototype.hasOwnProperty.call(current, part)
      ) {
        return fallbackValue;
      }

      current = current[part];
    }

    return current === undefined || current === null ? fallbackValue : current;
  } catch (error) {
    return fallbackValue;
  }
}
